import { existsFilter } from '@iotv/core-services';
import { BranchingQueryDefinition, edgeTypeMatrix, getAscendingGroupRecuriveQuery, getChildEdgeTypeId, getParentEdgeTypeId, HistoryStore, ObservationHistory, } from '@iotv/datamodel-core';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { identitiesMatch, isPosition, AdjacentType } from '@iotv/iotv-v3-types';
import { getGraphQueryRequestV2 } from '../../data/daoFunctions/GraphQueries/recursiveFilteredGraphQuery';
export const ObservationInputMetaKeys = ['fromTimestampMs', 'toTimestampMs', 'observationType', 'description', 'periodBasisMs'];
export const observationHistoryIsPeriodBased = (observationHistory) => {
    return observationHistory.observedHistory.keys().includes('fromTimestampMs') && observationHistory.observedHistory.keys().includes('toTimestampMs');
};
export const makeObservationHistoryPeriodBased = (observationHistory) => {
    if (observationHistoryIsPeriodBased(observationHistory)) {
        return observationHistory;
    }
    else {
        const newObservedHistory = new HistoryStore({
            timestamp: observationHistory.observedHistory.timestamp,
            index: observationHistory.observedHistory.index,
        });
        newObservedHistory.addKey('fromTimestampMs');
        newObservedHistory.addKey('toTimestampMs');
        return new ObservationHistory({ ...observationHistory, observedHistory: newObservedHistory });
    }
};
export const getObservationPeriod = (observationHistory) => {
    if (observationHistoryIsPeriodBased(observationHistory)) {
        const { fromTimestampMs, toTimestampMs } = observationHistory.observedHistory;
        const fromTimestampOut = Math.min(...fromTimestampMs.filter(existsFilter));
        const toTimestampMsOut = Math.max(...toTimestampMs.filter(existsFilter));
        return { fromTimestampMs: fromTimestampOut, toTimestampMs: toTimestampMsOut };
    }
    return null;
};
/** Via customer hubs - original */
const getRelatedVideoHubContexts = async (entity) => {
    const res = [];
    const { contextObjects, topLevelQuery } = getAscendingGroupRecuriveQuery({ groupDefiningObjectTypeId: 'Customer', item: entity });
    const { err, data: ascendantingGroupsRes } = await getGraphQueryRequestV2({ contextObjects: [entity], query: topLevelQuery });
    if (err) {
        console.error('getRelatedVideoHubContexts ascendantingGroupsRes err', err);
    }
    else if (ascendantingGroupsRes) {
        const groups = ascendantingGroupsRes.getNodesOfType('Customer');
        console.log(`getRelatedVideoHubContexts groups`, groups);
        const query = {
            contextObjects: groups,
            query: new BranchingQueryDefinition({
                id: 'apexQuery',
                path: [
                    { objectTypeId: 'VideoHub', edgeTypeId: getChildEdgeTypeId('Customer', 'VideoHub') },
                    { objectTypeId: 'VideoStream', edgeTypeId: getChildEdgeTypeId('VideoHub', 'VideoStream') },
                ],
            }),
        };
        const { err: queryResErr, data: queryResData } = await ConsumerDao.getGraphQueryRequestV2(query);
        if (queryResErr) {
            console.error('getRelatedVideoHubContexts queryResErr', queryResErr);
        }
        else if (queryResData) {
            console.log(`getRelatedVideoHubContexts summary`, queryResData.getSummary());
            const videoStreams = queryResData.getNodesOfType('VideoStream');
            console.log(`getRelatedVideoHubContexts videoStreams`, videoStreams.length);
            if (videoStreams.length > 0) {
                for (const videoStream of videoStreams) {
                    const context = queryResData.extractSingleNodeEdgeMapper(videoStream);
                    res.push(context);
                }
            }
        }
    }
    return res;
};
/** Via directly link to video streams */
export const getRelatedVideoStreams = async (entity) => {
    const res = [];
    const query = {
        contextObjects: [entity],
        query: new BranchingQueryDefinition({
            id: 'apexQuery',
            path: [
                { objectTypeId: 'VideoStream', edgeTypeId: getParentEdgeTypeId(entity.type, 'VideoStream') },
            ],
        }),
    };
    const { err: queryResErr, data: queryResData } = await ConsumerDao.getGraphQueryRequestV2(query);
    if (queryResErr) {
        console.error('getRelatedVideoStreams queryResErr', queryResErr);
    }
    else if (queryResData) {
        const videoStreams = queryResData.getNodesOfType('VideoStream');
        console.log(`getRelatedVideoStreams videoStreams`, videoStreams.length);
        if (videoStreams.length > 0) {
            res.push(...videoStreams);
        }
    }
    return res;
};
const getProximateVideoStreamsForEntity = async (entity) => {
    const res = [];
    const videoStreamsRes = isPosition(entity.location) ? await ConsumerDao.getProximateItems({
        objectTypeId: 'VideoStream',
        originPosition: entity.location,
        distance: 50,
        units: 'meters',
    }) : { err: new Error('Invalid position'), data: null };
    if (videoStreamsRes.err) {
        console.error('getProximateVideoStreamsForEntity queryResErr', videoStreamsRes.err);
    }
    else if (videoStreamsRes.data) {
        res.push(...videoStreamsRes.data.Items ?? []);
    }
    return res;
};
// via direct and proximate queries
export const getVideoStreamsContextsForEntity = async (entity) => {
    const related_videoStream = await getRelatedVideoStreams(entity);
    console.log(`getVideoStreamsForEntity related_videoStreams`, related_videoStream);
    const proximate_videoStreams = await getProximateVideoStreamsForEntity(entity);
    console.log(`getVideoStreamsForEntity proximate_videoStreams`, proximate_videoStreams);
    const videoStreams = [];
    for (const videoStream of [...related_videoStream, ...proximate_videoStreams]) {
        if (!videoStreams.some((vs) => identitiesMatch(vs, videoStream))) {
            videoStreams.push(videoStream);
        }
    }
    const videoStreamsContext = [];
    if (videoStreams.length > 0) {
        const hubContexts = await Promise.all(videoStreams.map(async (videoStream) => {
            const query = {
                contextObjects: [videoStream],
                query: new BranchingQueryDefinition({
                    id: 'apexQuery',
                    path: [
                        { objectTypeId: 'VideoHub', edgeTypeId: edgeTypeMatrix.VideoHub.VideoStream.videoHub_hosts_videoStream.edgeTypeId, adjacencyType: AdjacentType.PARENT },
                    ],
                    subQueries: []
                }),
            };
            const contextRes = await ConsumerDao.getGraphQueryRequestV2(query);
            console.log(`getVideoStreamsForEntity contextRes`, contextRes);
            return contextRes.data ? contextRes.data.extractSingleNodeEdgeMapper(videoStream) : null;
        }));
        for (const hubContext of hubContexts) {
            if (hubContext) {
                videoStreamsContext.push(hubContext);
            }
        }
    }
    return videoStreamsContext;
};
